import { render, staticRenderFns } from "./RecordingBadge.vue?vue&type=template&id=3aa9f855&scoped=true"
import script from "./RecordingBadge.vue?vue&type=script&lang=js"
export * from "./RecordingBadge.vue?vue&type=script&lang=js"
import style0 from "./RecordingBadge.vue?vue&type=style&index=0&id=3aa9f855&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa9f855",
  null
  
)

export default component.exports